
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inspiration",
      function () {
        return require("private-next-pages/inspiration/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inspiration"])
      });
    }
  